import { isLiveStream, isStreamingLive } from '@core/livestream/helpers';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import { liveStreamRunningAnnouncementSelector } from '@embed/components/VideoPlayer/Player3/store/selectors';
/**
 * A hook returning announcement for display on the running banner
 */
export const useRunningAnnouncement = () => {
    const liveStreamState = useStore((store) => store.liveStreamState);
    const video = useStore((store) => store.video);
    const liveStreamRunningAnnouncement = useStore((state) => liveStreamRunningAnnouncementSelector(state, video?.live_stream_id));
    const isLiveStreamLive = isStreamingLive(liveStreamState);
    let runningAnnouncement = '';
    if (isLiveStreamLive && Boolean(liveStreamRunningAnnouncement)) {
        runningAnnouncement = liveStreamRunningAnnouncement?.announcement || '';
    }
    else if (isLiveStream(video) && video) {
        runningAnnouncement = video?.live_stream_announcement || '';
    }
    return runningAnnouncement;
};
